<template>
  <div class="tags">
    <template v-if="!onlyExclusion">
      <div class="question">{{ $t('promotion_new.included_tags') }}</div>
      <MultiSelect :options="tags" :selected="promotion.inclusion.tags" :trackByAttribute="'value'"
                   @changed="promotion.inclusion.tags = $event"/>
    </template>

    <div class="question">{{ $t('promotion_new.excluded_tags') }}</div>
    <MultiSelect :options="tags" :selected="promotion.exclusion.tags" :trackByAttribute="'value'"
                 @changed="promotion.exclusion.tags = $event"/>
  </div>
</template>

<script>
import MultiSelect from "@/components/tools/MultiSelect";

export default {
  name: "PromotionTags",

  components: { MultiSelect },

  props: {
    tags: Array,
    onlyExclusion: Boolean,
    promotion: Object
  }
}
</script>